<template>
  <div class="coupon-formal-rules" aria-label="正式优惠券规则">
    <p>
      <strong>{{ coupon.templateName || "优惠券规则" }}</strong>
    </p>
    <dl>
      <dt>优惠</dt>
      <dd>
        {{ couponBenefit(coupon) }} · {{ couponThreshold(coupon)
        }}<template v-if="couponCap(coupon)">
          · {{ couponCap(coupon) }}</template
        >
      </dd>
      <dt>适用模块</dt>
      <dd>{{ coupon.moduleName || "模块未提供" }}</dd>
      <dt>适用范围</dt>
      <dd>
        <p v-for="(line, index) in couponScopeLines(coupon)" :key="index">
          {{ line }}
        </p>
      </dd>
      <dt>有效期</dt>
      <dd>{{ couponValidity(coupon) }}</dd>
      <template v-if="coupon.unavailableReason || coupon.occupied"
        ><dt>当前状态</dt>
        <dd>{{ coupon.unavailableReason || "已被预约占用" }}</dd></template
      >
    </dl>
    <p v-if="coupon.businessModule === 'PHOTOGRAPHY'">
      符合范围的摄影、化妆和场地合计参与门槛及优惠，平台费和独立额外精修交易不参与。
    </p>
    <p>
      规则以发放时冻结内容为准。每笔预约限用一张，不可叠加，提交时仍需校验使用资格。
    </p>
  </div>
</template>
<script>
import couponPresentation from "@/tool/couponPresentation.cjs";
export default {
  name: "CouponRules",
  props: { coupon: { type: Object, required: true } },
  methods: couponPresentation,
};
</script>
<style scoped>
.coupon-formal-rules {
  border-top: 1px solid #e9e9ef;
  padding-top: 12px;
  margin-top: 8px;
  font-size: 12px;
  line-height: 1.7;
  color: #777780;
  overflow-wrap: anywhere;
}
.coupon-formal-rules p {
  margin: 0 0 6px;
}
.coupon-formal-rules strong {
  color: #24242a;
}
.coupon-formal-rules dl {
  margin: 0 0 8px;
}
.coupon-formal-rules dt {
  color: #24242a;
  margin-top: 6px;
}
.coupon-formal-rules dd {
  margin: 0;
}
.coupon-formal-rules dd p {
  margin: 0;
}
</style>
